import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@holigral/shared/ui/components/ui/card"

type Props = {
  index: number
  title: string
  body: string
}

/**
 * One rung of the details staircase. A shadcn Card with the only spot of
 * colour on the page — the slate rung number (felt more than seen).
 */
export default function StepCard({ index, title, body }: Props) {
  return (
    <Card size="sm">
      <CardHeader>
        <div className="flex items-baseline gap-3">
          <span className="font-mono text-sm font-medium text-khepri-text tabular-nums">
            {String(index).padStart(2, "0")}
          </span>
          <CardTitle className="text-xl font-medium tracking-tight sm:text-[1.3rem]">
            {title}
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm leading-relaxed text-muted-foreground sm:text-[0.9rem]">
          {body}
        </p>
      </CardContent>
    </Card>
  )
}
